export default {
    methods: {
        //Split le date heure en un objet avec une propriété date et une propriété heure
        splitDate : function(dateHour){
            let array = dateHour.split(' ');
            let itemDate = {}
            itemDate.date = array[0]
            itemDate.hour = array[1]
            return itemDate
        },
        //Calcul du nombre de jour entre deux dates
        DaysBetween : function (StartDate, EndDate) {
            // Le nombre de millisecondes dans un jour
            const oneDay = 1000 * 60 * 60 * 24;
            // Transformation des dates en UTC pour ne pas avoir de problèmes avec les changements d'heures
            const start = Date.UTC(EndDate.getFullYear(), EndDate.getMonth(), EndDate.getDate()) + oneDay;
            const end = Date.UTC(StartDate.getFullYear(), StartDate.getMonth(), StartDate.getDate());
            return ((start - end) / oneDay);
        },
        parseDate: function(str){
            //Transformation des dates en date JS
            var dateArray = str.split("-");
            return new Date(dateArray[0], dateArray[1]-1, dateArray[2])
        },
        //Parse les dates du format jj/mm/aaaa en aaaa-mm-jj
        parseFrDateToUs: function(str){
            var dateArray = str.split('/')
            return dateArray[2]+"-"+dateArray[1]+"-"+dateArray[0]
        },
        //set le numero du jour de 1 a 7 (7 = dimanche) au lieu du getDay normal de 0 a 6 (ou 0 = dimanche)
        getBetterDay: function(dateObject){
            let day = dateObject.getDay();
            day == 0 ? day = 7 : day = day;
            return day
        },
        //Methode pour parser des heures en float
        parseHourToFloat : function(hour){
            const arrayHour = hour.split(':');
            const minutesToNumeric = arrayHour[1] * 100 / 60
            return parseFloat(arrayHour[0]+"."+minutesToNumeric)
        },
         //Methode pour parser des float en heures
        parseFloatToHour : function(floatHour){
            //Si entier alors on peut la renvoyer telle quelle avec :00
            if(Number.isInteger(floatHour)){
                return floatHour+":00"
            } else {
                const stringFloatHour = ""+floatHour;
                const arrayFloat = stringFloatHour.split('.');
                let numericToMinutes = (arrayFloat[1] * 60 / 100)+""
                if(numericToMinutes.length == 1){
                    numericToMinutes = numericToMinutes +"0"
                }
                return arrayFloat[0]+":"+numericToMinutes
            }           
        }
    }
}